import { mountHTTPInstance } from '@ghq-abi/auth-client-lib/client';

export const api = mountHTTPInstance({
    baseURL: process.env.NEXT_PUBLIC_ONEVERSE_API_URL,
});

export const nextApi = mountHTTPInstance({
    baseURL: process.env.NEXT_PUBLIC_BOILERPLATE_APP_URL,
});

export const peoplePlatformApi = mountHTTPInstance({
    baseURL: process.env.NEXT_PUBLIC_PEOPLE_PLATFORM_API_URL,
});
